import * as React from "react";
import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { Button } from "../../components";
import { useApi, useNavigation } from "../../hooks";
import { PlaceOrderResponse } from "../../apis/order";
import { Constants, Tools } from "../../utils";
import { Tags } from "../../libs";
import { TagsEvent } from "../../libs/tags";
import { useTranslation } from "react-i18next";

export type StripeCheckoutElementProps = {
  payLabel: string;
};

export default function StripeCheckoutElement(
  props: StripeCheckoutElementProps,
) {
  const stripe = useStripe();
  const elements = useElements();
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(true);
  const { data } = useNavigation() as { data: PlaceOrderResponse };
  const { fetch } = useApi();

  const onPay = React.useCallback(async () => {
    Tags.ecommerce(
      TagsEvent.AddPaymentInfo,
      Tools.orderItemsToAnalyticsItems(data.order?.order_items ?? []),
    );
    try {
      await fetch(async () => {
        if (!stripe || !elements) return;
        const { error } = await stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url: `${window.location.origin}${Constants.urls.bookingSuccess({ order_id: data.order.id, code: data.order.code })}`,
          },
        });
        if (!error) return;
        throw new Error(error.message ?? t("errors.somethingWentWrong"));
      });
    } catch {}
  }, [data.order, elements, fetch, stripe, t]);

  return (
    <div className="grid gap-[16px]">
      <PaymentElement
        id="payment-element"
        options={{ layout: "tabs" }}
        onReady={() => setLoading(false)}
        onLoaderStart={() => setLoading(true)}
      />
      <Button
        className="w-full"
        color="primary"
        onClick={onPay}
        disabled={!stripe || !elements || loading}
      >
        {props.payLabel}
      </Button>
    </div>
  );
}
